import { createMulticall, ListenerOptions } from "@uniswap/redux-multicall";
import { useInterfaceMulticall } from "src/hooks/useContract";
import useBlockNumber from "src/lib/hooks/useBlockNumber";
import { useEffect, useMemo } from "react";
import { useWeb3Context } from "src/hooks";
import { useDataList } from "src/hooks/useDataList";
import { batch, useDispatch } from "react-redux";
import { loadAppDetails } from "src/slices/AppSlice";
import { SupportedChainId } from "src/constants/chainENV/chains.base";

const multicall = createMulticall();

export default multicall;

export function getBlocksPerFetchForChainId(
  chainId: number | undefined
): number {
  switch (chainId) {
    case SupportedChainId.ARBITRUM:
    case SupportedChainId.ARB_TEST:
      return 45;
    case SupportedChainId.BSCTEST:
    case SupportedChainId.BSCMAINNET:
      return 2;
    default:
      return 1;
  }
}

export function MulticallUpdater() {
  const { chainID: chainId } = useWeb3Context();
  const latestBlockNumber = useBlockNumber();
  const contract = useInterfaceMulticall();
  const DataList = useDataList();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!DataList) return;
    batch(() => {
      dispatch(loadAppDetails(DataList));
    });
  }, [DataList, dispatch]);

  const listenerOptions: ListenerOptions = useMemo(
    () => ({
      blocksPerFetch: getBlocksPerFetchForChainId(chainId),
    }),
    [chainId]
  );

  return (
    <multicall.Updater
      chainId={chainId}
      latestBlockNumber={latestBlockNumber}
      contract={contract}
      listenerOptions={listenerOptions}
    />
  );
}
